import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessModeSettings } from "@/shared/types/api/business-mode.types"

export const businessSettingsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessConnectionSettings"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      // Settings are stored per user, so this always answers — defaults included —
      // whether or not a business connection is attached.
      getBusinessSettings: builder.query<BusinessModeSettings, undefined>({
        query: () => "/api/v1/business/connections/settings",
        providesTags: () => [{ type: "BusinessConnectionSettings" as const }]
      })
    })
  })

export const { useGetBusinessSettingsQuery } = businessSettingsApi
